import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog, HideOnPrint } from 'components';
import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import policyOverview from 'features/views/policyOverview';
import { resetToInitialState } from 'features/views/policyOverview/actions';
import { dialogs } from 'features/views/policyOverview/constants';
import formDescriptorFn, { POLICY_OVERVIEW_FILTER_FORM_NAME } from 'features/views/policyOverview/form';

import FilterNew from './components/FilterNew';
import ResultsTable from './components/ResultsTable';
import Toolbar from './components/Toolbar';

export const PolicyOverview = () => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(resetToInitialState());
		},
		[dispatch],
	);

	const floatingDialogs = (
		<HideOnPrint>
			<Dialog mui name={policyOverview.constants.dialogs.tooManyResults}>
				{getLabelMessage('common:tooManyResultsPolicy')}
			</Dialog>
			<Dialog mui name={policyOverview.constants.dialogs.tooManyResults408}>
				{getLabelMessage('common:tooManyResultsPolicy')}
			</Dialog>
			<Dialog mui name={dialogs.subsellerLoginAgencyNoAndWithSubordinatesConflict}>
				{getLabelMessage('common:subsellerLoginAgencyNoAndWithSubordinatesConflict')}
			</Dialog>
			<Dialog mui name={dialogs.subsellerNotFound}>
				{getLabelMessage('common:subsellerNotFound')}
			</Dialog>
			<Dialog mui name={dialogs.atLeastOneContractTypeCheckboxSelected}>
				{getLabelMessage('common:atLeastOneContractTypeCheckboxSelected')}
			</Dialog>
		</HideOnPrint>
	);

	return (
		<Panel
			screenId={PAGES.policyOverview.id}
			screenName={PAGES.policyOverview.name}
			floatingDialogs={floatingDialogs}
		>
			<Form name={POLICY_OVERVIEW_FILTER_FORM_NAME} formDescriptorFn={formDescriptorFn}>
				<PaperWithToolbar
					toggledElement={
						<HideOnPrint>
							<FilterNew />
						</HideOnPrint>
					}
					toolbar={<Toolbar />}
					collapsibleProps={{ id: subheaders.policyOverview, initiallyOpen: true }}
				>
					<ResultsTable />
				</PaperWithToolbar>
			</Form>
		</Panel>
	);
};

export default PolicyOverview;
